export const LETTER_STAGGER = 0.05;
export const LETTER_DURATION = 2;

export function prefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function phraseAnimationPlan(text, { reduced = false, preset = 'linear' } = {}) {
  const source = String(text);
  if (reduced) {
    return { mode: 'instant', preset, text: source, letters: [] };
  }

  const letters = [];
  let delay = 0;
  source.split('\n').forEach((line, lineIndex) => {
    [...line].forEach((ch) => {
      letters.push({
        ch,
        lineIndex,
        delay,
        duration: LETTER_DURATION,
        preset,
      });
      delay += LETTER_STAGGER;
    });
  });

  return { mode: 'letters', preset, text: source, letters };
}
